import { FC } from 'react';
import { Trans } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface SubmissionsTableHeaderProps {
  className?: string;
}

export const SubmissionsTableHeader: FC<SubmissionsTableHeaderProps> = ({
  className,
}: SubmissionsTableHeaderProps) => (
  <TableHeader className={cn(className)}>
    <TableRow>
      <TableHead>
        <Trans i18nKey='submissions.columns.id' />
      </TableHead>
      <TableHead>
        <Trans i18nKey='submissions.columns.department' />
      </TableHead>
      <TableHead>
        <Trans i18nKey='submissions.columns.counts' />
      </TableHead>
      <TableHead>
        <Trans i18nKey='submissions.columns.status' />
      </TableHead>
    </TableRow>
  </TableHeader>
);
